"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPages = void 0;
var getPages = function (pageTotal, pageSelected, margin, padding) {
    var pages = [];
    var pagesNumbers = [];
    var insertPage = function (n) {
        if (n >= 1 && n <= pageTotal) {
            pagesNumbers.push(n);
        }
    };
    var paddingLeft = pageSelected - padding;
    var paddingRight = pageSelected + padding;
    if (paddingLeft < 1 && paddingRight > pageTotal) {
        paddingLeft = 1;
        paddingRight = pageTotal;
    }
    else if (paddingLeft < 1) {
        while (paddingLeft < 1) {
            paddingLeft++;
            paddingRight++;
        }
    }
    else if (paddingRight > pageTotal) {
        while (paddingRight > pageTotal) {
            paddingLeft--;
            paddingRight--;
        }
    }
    for (var i = 1; i <= margin; i++) {
        var left = i;
        var right = pageTotal - (i - 1);
        if (left >= paddingLeft) {
            paddingRight++;
        }
        else {
            insertPage(left);
        }
        if (right <= paddingRight) {
            paddingLeft--;
        }
        else {
            insertPage(right);
        }
    }
    for (var i = paddingLeft; i <= paddingRight; i++) {
        insertPage(i);
    }
    var sortedPages = pagesNumbers
        .slice()
        .sort(function (a, b) { return a - b; })
        .filter(function (page, index, array) { return !index || page !== array[index - 1]; });
    for (var index = 0; index < sortedPages.length; index++) {
        var current = sortedPages[index];
        var selected = current === pageSelected;
        if (index === 0) {
            if (current !== 1) {
                pages.push({
                    type: "BREAK",
                    number: 1,
                });
            }
            pages.push({
                type: "NUMBER",
                number: current,
                selected: selected,
            });
        }
        else {
            var last = sortedPages[index - 1];
            var delta = current - last;
            if (delta === 1) {
                pages.push({
                    type: "NUMBER",
                    number: current,
                    selected: selected,
                });
            }
            else {
                pages.push({
                    type: "BREAK",
                    number: current - 1,
                });
                pages.push({
                    type: "NUMBER",
                    number: current,
                    selected: selected,
                });
            }
        }
    }
    var lastPage = pages[pages.length - 1];
    if (lastPage.type === "NUMBER" && lastPage.number !== pageTotal) {
        pages.push({
            type: "BREAK",
            number: pageTotal,
        });
    }
    return pages;
};
exports.getPages = getPages;
//# sourceMappingURL=model.js.map